export default __webpack_public_path__ + "static/media/EditarIconGray.ebfa86fc.svg";